import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export function EntryForm({ stockItems, onClose, authAxios }) {
  const [stockId, setStockId] = useState("");
  const [quantity, setQuantity] = useState("");
  const [costTotal, setCostTotal] = useState("");
  const [supplier, setSupplier] = useState("");
  const [notes, setNotes] = useState("");
  const [loading, setLoading] = useState(false);

  const selected = stockItems.find(s => s.id === stockId);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await authAxios.post("/stock/entries", {
        stock_id: stockId,
        quantity: parseFloat(quantity),
        cost_total: parseFloat(costTotal || "0"),
        supplier,
        notes,
      });
      toast.success("Entrada registrada");
      onClose();
    } catch {
      toast.error("Error");
    }
    setLoading(false);
  };

  return (
    <>
      <DialogHeader><DialogTitle>Registrar Compra</DialogTitle></DialogHeader>
      <form onSubmit={handleSubmit} className="space-y-4 mt-4">
        <div className="space-y-2">
          <Label>Ingrediente</Label>
          <Select value={stockId} onValueChange={setStockId}>
            <SelectTrigger data-testid="entry-stock"><SelectValue placeholder="Seleccionar..." /></SelectTrigger>
            <SelectContent>
              {stockItems.map(s => (
                <SelectItem key={s.id} value={s.id}>
                  {s.name} (actual: {s.current_quantity} {s.unit})
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label>Cantidad ({selected?.unit || "?"})</Label>
            <Input type="number" step="0.01" value={quantity} onChange={e => setQuantity(e.target.value)} required data-testid="entry-qty" />
          </div>
          <div className="space-y-2">
            <Label>Coste total (EUR)</Label>
            <Input type="number" step="0.01" value={costTotal} onChange={e => setCostTotal(e.target.value)} data-testid="entry-cost" />
          </div>
        </div>
        <div className="space-y-2">
          <Label>Proveedor</Label>
          <Input value={supplier} onChange={e => setSupplier(e.target.value)} />
        </div>
        <div className="space-y-2">
          <Label>Notas</Label>
          <Input value={notes} onChange={e => setNotes(e.target.value)} />
        </div>
        <DialogFooter>
          <Button type="button" variant="secondary" onClick={onClose}>Cancelar</Button>
          <Button type="submit" disabled={loading || !stockId} data-testid="entry-save">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Registrar"}
          </Button>
        </DialogFooter>
      </form>
    </>
  );
}
